import React from 'react';
import { Box, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import ClientAgrPanel from '../components/ConsentComponents/ClientAgrPanel';
import EDeliveryPanel from '../components/ConsentComponents/EDeliveryPanel';
import InvInfoPanel from '../components/ConsentComponents/InvInfoPanel';
import ExpansionPanelConsent from '../components/shared/ExpansionPanelConsent';
import { PsBeaconButton } from '../components/shared/BeaconRegister';
import KeyPointsPanel from '../components/ConsentComponents/KeyPointsPanel';
import ProspectusPanel from '../components/ConsentComponents/ProspectusPanel';
import SelectionError from '../components/shared/Errors/SelectionError';
import LoadingSpinner from './LoadingSpinner';
import { acctSelHeader } from '../components/ConsentComponents/ConsentContent';

const ConsentViewContainer = ({
    handleChange,
    isCustomerWebView,
    inProgress,
    checkError,
    handleDispatch,
    success,
    isPrimary,
    isRegisteredUser,
    numberOfClients,
    notificationContent,
}) => {
    const checkIfCoClient =
        window.location.pathname.indexOf('co-client-consent') !== -1 &&
        window.location.pathname.indexOf('reenroll') === -1;
    const showYodleeConsent =
        isRegisteredUser && !checkIfCoClient && (numberOfClients > 0 ? isPrimary : true);
    const [buttonSize, setButtonSize] = React.useState(
        window.innerWidth <= 600 ? '100%' : 'inherit'
    );
    const smallScreenSize = window.matchMedia('(max-width: 600px)');

    smallScreenSize.addEventListener('change', function () {
        setButtonSize(smallScreenSize.matches ? '100%' : 'inherit');
    });

    return (
        <Box className="beacon-theme-modern-outlook beacon-on-light">
            <Box
                sx={{ backgroundColor: '#fff', inlineSize: 'unset !important', paddingTop: '40px' }}
                className="b-container-content">
                {(checkError.checkedKeyPoints ||
                    checkError?.checkedProspectuses ||
                    checkError.checkedConfirmation ||
                    checkError.checkedEdelivery ||
                    checkError.checkedAdv) && (
                    <Box sx={{ paddingBottom: '48px' }}>
                        <SelectionError errors={notificationContent} />
                    </Box>
                )}
                <Typography
                    type="headline" serif scale={400} bold
                    id="e-delivery-modal-title">
                    Terms of Service
                </Typography>
                <Typography
                    id="e-delivery-modal-subtitle"
                    light
                    sx={{ paddingBottom: '32px' }}>
                    To view your financial plan, complete each section of the Terms of Service
                    below.
                </Typography>
                <ExpansionPanelConsent>
                    <KeyPointsPanel
                        panelNum="I"
                        open
                        handleChange={handleChange}
                        checkError={checkError}
                    />
                    <EDeliveryPanel
                        panelNum="II"
                        open
                        handleChange={handleChange}
                        checkError={checkError}
                    />
                    <ProspectusPanel
                        includeHeader
                        panelNum="III"
                        prospectusesDisplay
                        open
                        showCheckbox
                        handleChange={handleChange}
                        checkError={checkError}
                    />
                    <ClientAgrPanel
                        panelNum="IV"
                        handleChange={handleChange}
                        checkError={checkError}
                        checkBox
                        open
                    />
                    <InvInfoPanel
                        panelNum="V"
                        headerText={acctSelHeader}
                        showYodleeConsent={showYodleeConsent}
                        handleChange={handleChange}
                        checkError={checkError}
                        open
                    />
                    <div style={{ paddingBottom: 120, paddingTop: 32 }}>
                        <PsBeaconButton
                            onClick={handleDispatch}
                            disabled={isCustomerWebView}
                            id="i-agree-to-terms"
                            style={{ width: buttonSize }}
                            state={success ? 'success' : ''}
                            scale="jumbo">
                            {!inProgress && 'Continue'}
                            {inProgress && <LoadingSpinner scale="mini" text="Loading..." />}
                        </PsBeaconButton>
                    </div>
                </ExpansionPanelConsent>
            </Box>
        </Box>
    );
};

export default ConsentViewContainer;
